(() => {
  'use strict';
  const initialized = new WeakSet();
  const personalDomains = new Set('gmail.com googlemail.com hotmail.com hotmail.nl outlook.com outlook.nl live.com live.nl msn.com yahoo.com yahoo.nl yahoo.co.uk icloud.com me.com mac.com aol.com proton.me protonmail.com pm.me mail.com gmx.com gmx.de gmx.net ymail.com zoho.com fastmail.com hey.com tuta.com tutanota.com kpnmail.nl planet.nl hetnet.nl xs4all.nl ziggo.nl home.nl upcmail.nl casema.nl chello.nl online.nl telfort.nl wanadoo.nl orange.nl solcon.nl zeelandnet.nl delta.nl caiway.nl mailinator.com guerrillamail.com yopmail.com 10minutemail.com example.com example.org example.net'.split(' '));
  const businessEmail = value => {
    const domain = String(value).trim().toLowerCase().split('@')[1];
    return Boolean(domain && domain.includes('.') && !Array.from(personalDomains).some(blocked => domain === blocked || domain.endsWith(`.${blocked}`)));
  };
  function initialize(root) {
    if (initialized.has(root)) return;
    initialized.add(root);
    const form = root.querySelector('[data-webinar-form]');
    const dialog = root.querySelector('[data-registration-dialog]');
    let trigger;
    const messages = JSON.parse(root.querySelector('[data-webinar-messages]').textContent);
    const submit = form.querySelector('[data-submit]');
    const email = form.elements.email;
    const industry = form.elements.industry;
    const other = form.elements.industry_other;
    const goal = form.elements.goal;
    const errorBox = form.querySelector('[data-form-error]');
    const success = form.querySelector('[data-form-success]');
    const fields = form.querySelector('[data-form-fields]');
    const endpoint = root.dataset.endpoint.trim();
    let endpointValid = false;
    try {
      const url = new URL(endpoint, window.location.origin);
      endpointValid = Boolean(endpoint) && (url.protocol === 'https:' || (url.origin === window.location.origin && url.protocol === 'http:' && ['localhost', '127.0.0.1'].includes(url.hostname)));
    } catch {}
    let busy = false;
    submit.disabled = !endpointValid || form.elements.session_id.options.length < 2;
    const clearError = () => { errorBox.hidden = true; errorBox.textContent = ''; };
    const syncIndustry = () => {
      const isOther = industry.value === 'other';
      root.querySelector('[data-other-industry]').hidden = !isOther;
      other.disabled = !isOther;
      other.required = isOther;
      if (!isOther) other.value = '';
    };
    industry.addEventListener('change', syncIndustry);
    syncIndustry();
    email.addEventListener('input', () => { email.setCustomValidity(''); email.removeAttribute('aria-invalid'); clearError(); });
    email.addEventListener('blur', () => {
      email.setCustomValidity(email.value && !businessEmail(email.value) ? messages.businessEmail : '');
      if (email.validationMessage) email.setAttribute('aria-invalid', 'true');
    });
    goal.addEventListener('input', () => goal.setCustomValidity(''));
    root.querySelectorAll('[data-select-session]').forEach(link => link.addEventListener('click', event => {
      event.preventDefault();
      if (busy) return;
      trigger = link;
      if (dialog && !dialog.open) dialog.showModal();
      if (!success.hidden) reset();
      form.elements.session_id.value = link.dataset.selectSession;
      clearError();
      requestAnimationFrame(() => form.elements.session_id.focus({ preventScroll: true }));
    }));
    if (dialog) {
      dialog.querySelector('[data-close-registration]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => trigger?.focus({ preventScroll: true }));
    }
    function reset() {
      form.reset();
      syncIndustry();
      clearError();
      success.hidden = true;
      fields.hidden = false;
      submit.disabled = !endpointValid || form.elements.session_id.options.length < 2;
      email.setCustomValidity('');
      goal.setCustomValidity('');
      form.elements.session_id.focus({ preventScroll: true });
    }
    form.querySelector('[data-register-another]').addEventListener('click', reset);
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (busy || !endpointValid) return;
      clearError();
      email.setCustomValidity(businessEmail(email.value) ? '' : messages.businessEmail);
      goal.setCustomValidity(goal.value.trim().length >= 10 ? '' : messages.invalid);
      if (!form.reportValidity()) return;
      const payload = Object.fromEntries(new FormData(form));
      payload.email = payload.email.trim().toLowerCase();
      payload.consent = payload.consent === 'yes';
      payload.privacy_version = 'webinar-v1';
      const sessionLabel = form.elements.session_id.selectedOptions[0].textContent;
      busy = true;
      submit.disabled = true;
      form.setAttribute('aria-busy', 'true');
      submit.textContent = messages.loading;
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 20000);
      try {
        const response = await fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'omit', body: JSON.stringify(payload), signal: controller.signal });
        const result = await response.json();
        if (!response.ok || result.ok !== true || !result.registration_id || result.confirmation_queued !== true) {
          const codeMessages = { business_email_required: messages.businessEmail, invalid_fields: messages.invalid, session_closed: messages.closed, rate_limited: messages.rateLimited };
          throw new Error(codeMessages[result.error] || messages.error);
        }
        success.querySelector('[data-success-session]').textContent = sessionLabel;
        fields.hidden = true;
        success.hidden = false;
        form.reset();
        syncIndustry();
        success.focus({ preventScroll: true });
        success.scrollIntoView({ behavior: 'auto', block: 'center' });
      } catch (error) {
        errorBox.textContent = error.name === 'AbortError' || error instanceof TypeError || error instanceof SyntaxError ? messages.error : error.message;
        errorBox.hidden = false;
      } finally {
        clearTimeout(timer);
        busy = false;
        submit.disabled = false;
        form.removeAttribute('aria-busy');
        submit.textContent = messages.submit;
      }
    });
  }
  function boot(scope = document) { scope.querySelectorAll('[data-webinars]').forEach(initialize); }
  boot();
  document.addEventListener('shopify:section:load', event => boot(event.target));
})();
